<template>
  <div class="perfil-container">
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    />
    <div v-if="loading" class="overlay">
      <div><img class="spinner" src="loading.gif" alt="Loading data..." /></div>
    </div>
    <div v-if="showingPopup" class="popup-overlay">
      <div class="popup">
        <p>{{ popupMessage }}</p>
        <button @click="closePopup" class="btn-close">Fechar</button>
      </div>
    </div>
    <h1 class="perfil-titulo">Perfil do Usuário</h1>

    <div class="perfil-card">
      <div class="form-group">
        <label for="username">Username:</label>
        <input type="text" id="username" v-model="username" disabled />
      </div>

      <div class="form-group">
        <label for="name">Name:</label>
        <input type="text" id="name" v-model="name" />
      </div>

      <div class="form-group">
        <label for="email">Email:</label>
        <input type="text" id="email" v-model="email" />
      </div>

      <div class="form-group">
        <label for="supplierNumber">Número de fornecedor:</label>
        <input type="text" id="supplierNumber" v-model="supplierNumber" />
      </div>
      <div class="form-group">
        <label for="dsr_code">Código de vendedor:</label>
        <input type="text" id="dsr_code" v-model="dsr_code" />
      </div>

      <div>
        <button
          @click="saveProfileChanges"
          :disabled="loading"
          class="btn-salvar"
        >
          Guardar alterações
        </button>
      </div>
      <br />

      <div class="form-group">
        <label for="payment_method">
          Método de pagamento atual (Última atualização efetuada a
          {{ payment_method_date }}):
        </label>
        <input
          type="text"
          id="payment_method"
          :value="formattedPaymentMethod"
          disabled
        />

        <!-- 🟧 Conditional label above the select or info section -->
        <div v-if="!dsr_payment_method">
          <label for="paymentMethod"
            ><br />Selecione um método de pagamento:</label
          >
          <select id="paymentMethod" v-model="paymentMethod" class="dropdown">
            <option
              v-for="option in availablePaymentOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div>

        <div v-else>
          <label for="payment_method"
            ><br />
            Alterar método de pagamento para:
            {{ paymentMethodLabel(alternativePaymentMethodValue) }}
          </label>
          <!-- Display only the name, since there's only one alternative -->
        </div>
      </div>

      <div>
        <button
          @click="savePaymentChanges"
          :disabled="loading"
          class="btn-salvar"
        >
          Alterar método de pagamento
        </button>
      </div>

      <br />

      <div class="form-group">
        <label for="newPassword">Nova Palavra-passe:</label>
        <div style="position: relative">
          <input
            :type="showPassword ? 'text' : 'password'"
            id="newPassword"
            v-model="newPassword"
            placeholder="Nova senha"
            @input="passwordTouched = true"
            required
            style="padding-right: 30px"
          />
          <i
            :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
            @click="togglePasswordVisibility"
            style="
              position: absolute;
              right: 10px;
              top: 50%;
              transform: translateY(-50%);
              cursor: pointer;
            "
          ></i>
        </div>
      </div>

      <div class="password-rules">
        <p
          class="pass-validation"
          :class="{
            valid: hasMinLength,
            invalid: !hasMinLength && passwordTouched,
          }"
        >
          Mínimo 8 caracteres
        </p>
        <p
          class="pass-validation"
          :class="{
            valid: hasUppercase,
            invalid: !hasUppercase && passwordTouched,
          }"
        >
          Pelo menos uma letra maiúscula
        </p>
        <p
          class="pass-validation"
          :class="{
            valid: hasLowercase,
            invalid: !hasLowercase && passwordTouched,
          }"
        >
          Pelo menos uma letra minúscula
        </p>
        <p
          class="pass-validation"
          :class="{ valid: hasNumber, invalid: !hasNumber && passwordTouched }"
        >
          Pelo menos um número
        </p>
        <p
          class="pass-validation"
          :class="{ valid: hasSymbol, invalid: !hasSymbol && passwordTouched }"
        >
          Pelo menos um símbolo (ex: !@#$%)
        </p>
      </div>

      <div class="form-group">
        <label for="confirmPassword">Confirme a Nova Palavra-passe:</label>
        <div style="position: relative">
          <input
            :type="showConfirmationPassword ? 'text' : 'password'"
            id="newPassword"
            v-model="confirmPassword"
            placeholder="Confirmação da nova senha"
            @input="passwordTouched = true"
            required
            style="padding-right: 30px"
          />
          <i
            :class="showConfirmationPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
            @click="toggleConfirmationPasswordVisibility"
            style="
              position: absolute;
              right: 10px;
              top: 50%;
              transform: translateY(-50%);
              cursor: pointer;
            "
          ></i>
        </div>
      </div>

      <button @click="savePassChanges" :disabled="loading" class="btn-salvar">
        Guardar Nova Palavra-passe
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      showingPopup: false,
      popupMessage: "",
      loading: false,
      name: null,
      username: null,
      email: null,
      dsr_code: null,
      supplierNumber: null,
      originaldsr_code: null,
      originalUsername: null,
      originalEmail: null,
      originalSupplierNumber: null,
      originalEmail: null,
      dsr_payment_method: "",
      payment_method_date: null,
      paymentMethod: 1,
      newPassword: "",
      confirmPassword: "",
      passwordTouched: false,
      showPassword: false,
      showConfirmationPassword: false,
    };
  },

  computed: {
    //123Testes.
    hasMinLength() {
      return this.newPassword.length >= 8;
    },
    hasUppercase() {
      return /[A-Z]/.test(this.newPassword);
    },
    hasLowercase() {
      return /[a-z]/.test(this.newPassword);
    },
    hasNumber() {
      return /[0-9]/.test(this.newPassword);
    },
    hasSymbol() {
      return /[\W_]/.test(this.newPassword);
    },

    formattedPaymentMethod() {
      return this.paymentMethodLabel(this.dsr_payment_method);
    },

    isPasswordStrong() {
      return (
        this.hasMinLength &&
        this.hasUppercase &&
        this.hasLowercase &&
        this.hasNumber &&
        this.hasSymbol
      );
    },

    availablePaymentOptions() {
      if (!this.dsr_payment_method) {
        return [
          { value: 1, label: "Entidade Patronal" },
          { value: 2, label: "Ato Isolado" },
        ];
      }
      return this.dsr_payment_method === 1
        ? [{ value: 2, label: "Ato Isolado" }]
        : [{ value: 1, label: "Entidade Patronal" }];
    },
    alternativePaymentMethodValue() {
      return this.dsr_payment_method === 1 ? 2 : 1;
    },
    alternativePaymentMethodValue() {
      if (this.dsr_payment_method === 1) return 2;
      if (this.dsr_payment_method === 2) return 1;
      return null;
    },
  },

  mounted() {
    this.fetchDsrId();
    // this.carregarPerfil();
    this.fetchUser();
    if (this.dsr_payment_method) {
      this.paymentMethod = this.alternativePaymentMethodValue;
    }
  },

  watch: {
    dsr_payment_method(newVal) {
      if (newVal) {
        this.paymentMethod = this.alternativePaymentMethodValue;
      }
    },
  },

  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmationPasswordVisibility(){
      this.showConfirmationPassword = !this.showConfirmationPassword;
    },
    selectAlternativePayment() {
      this.paymentMethod = this.alternativePaymentMethodValue;
    },

    paymentMethodLabel(code) {
      if (code === 1) return "Entidade Patronal";
      if (code === 2) return "Ato Isolado";
      return "Método não definido";
    },

    showPopup(message) {
      this.popupMessage = message;
      this.showingPopup = true;
    },

    closePopup() {
      console.log("Fechar o popup");
      this.showingPopup = false;
      this.popupMessage = "";
    },

    fetchDsrId() {
      this.loading = true;
      this.error = null;
      this.dsr_id = null;
      this.dsr_payment_method = null;
      this.supplier_number = null;
      this.name = null;
      this.dsr_code = null;
      this.payment_method_date = null;

      this.axios
        .get("app/getDsrId")
        .then((response) => {
          // Assuming response.data contains the object with the name field
          this.dsr_id = response.data.dsr_id;
          this.dsr_code = response.data.dsr_code;
          this.dsr_payment_method = response.data.payment_method;
          this.payment_method_date = response.data.payment_update;
          this.supplierNumber = response.data.nif;
          this.name = response.data.name;
          this.loading = false;
        })
        .catch((error) => {
          this.error = error.message;
          this.loading = false;
        });
    },

    fetchUser() {
      axios
        .get("app/getInfo")
        .then((response) => {
          console.log("Response data:", response.data);
          // this.name = response.data.name || "Nome não encontrado";
          this.username = response.data.username || "Nome não encontrado";
          this.originalUsername = this.username;
          this.email = response.data.email || "Email não encontrado";
          this.originalEmail = this.email;
        })
        .catch((error) => {
          console.error("Error fetching user info:", error);
          this.name = "Erro ao carregar nome";
          this.username = "Erro ao carregar username";
          this.email = "Erro ao carregar email";
        });
    },

    async saveProfileChanges() {
      if (this.loading) return;
      this.loading = true;

      const changedData = {};
      if (this.name !== this.originalName) changedData.name = this.name;
      if (this.email !== this.originalEmail) changedData.email = this.email;
      if (this.supplierNumber !== this.originalSupplierNumber)
        changedData.supplier_number = this.supplierNumber;
      if (this.dsr_code !== this.originaldsr_code)
        changedData.dsr_code = this.dsr_code;

      if (Object.keys(changedData).length === 0) {
        this.showPopup("No changes detected.");
        this.loading = false;
        return;
      }

      try {
        const response = await axios.put("/app/changeProfileData", changedData);

        if (response.status === 200) {
          this.showPopup("Perfil atualizado com sucesso!");
          this.originalName = this.name;
          this.originalEmail = this.email;
          this.originalSupplierNumber = this.supplierNumber;
          this.originaldsr_code = this.dsr_code;
        } else {
          this.showPopup("Failed to update profile.");
        }
      } catch (error) {
        console.error("Error updating profile:", error);
        this.showPopup("An error occurred while updating the profile.");
      } finally {
        this.loading = false;
      }
    },

    async savePaymentChanges() {
      if (this.loading) return;
      this.loading = true;

      const paymentChanged = this.paymentMethod !== this.dsr_payment_method;

      if (!paymentChanged) {
        this.showPopup("Nenhuma alteração feita.");
        this.loading = false;
        return;
      }

      console.log("Selected payment method:", this.paymentMethod);

      try {
        const response = await axios.put(
          `/app/updatePaymentMethod/${this.paymentMethod}`
        );
        if (response.status === 200) {
          this.showPopup("Método de pagamento atualizado com sucesso!");
          setTimeout(() => {
            window.location.reload();
          }, 1500);
          // this.dsr_payment_method = this.paymentMethod;
        } else {
          this.showPopup("Erro ao atualizar método de pagamento.");
        }
      } catch (error) {
        console.error("Erro ao atualizar método de pagamento:", error);
        this.showPopup(
          "Erro ao atualizar método de pagamento. Tente novamente."
        );
      } finally {
        this.loading = false;
      }
    },

    validatePassword() {
      const password = this.newPassword;
      const confirmPassword = this.confirmPassword;

      if (!password || !confirmPassword) {
        this.showPopup("Preencha todos os campos necessários.");
        return false;
      }

      if (password !== confirmPassword) {
        this.showPopup("As novas senhas não coincidem.");
        return false;
      }

      // Password strength rules
      const hasMinLength = password.length >= 8;
      const hasUpper = /[A-Z]/.test(password);
      const hasLower = /[a-z]/.test(password);
      const hasLetter = /[A-Za-z]/.test(password);
      const hasNumber = /\d/.test(password);
      const hasSymbol = /[^A-Za-z0-9]/.test(password);

      if (!hasMinLength) {
        this.showPopup("A senha deve ter pelo menos 8 caracteres.");
        return false;
      }

      if (!hasUpper || !hasLower) {
        this.showPopup("A senha deve conter letras maiúsculas e minúsculas.");
        return false;
      }

      if (!hasLetter) {
        this.showPopup("A senha deve conter pelo menos uma letra.");
        return false;
      }

      if (!hasNumber) {
        this.showPopup("A senha deve conter pelo menos um número.");
        return false;
      }

      if (!hasSymbol) {
        this.showPopup("A senha deve conter pelo menos um símbolo.");
        return false;
      }

      return true;
    },

    async savePassChanges() {
      if (!this.validatePassword()) return;

      try {
        const response = await axios.post("/auth/reset", {
          username: this.username,
          password: this.newPassword,
          password_confirmation: this.confirmPassword,
        });

        this.showPopup(response.data.message);

        this.newPassword = "";
        this.confirmPassword = "";
      } catch (error) {
        this.showPopup("Erro ao redefinir a senha.");
      } finally {
        this.loading = false;
      }
    },

    // async carregarPerfil() {
    //   try {
    //     const response = await fetch("/api/perfil");
    //     const data = await response.json();
    //     this.perfil = data;
    //   } catch (error) {
    //     console.error("Erro ao carregar perfil:", error);
    //   }
    // },
  },
};
</script>

<style>
#paymentMethod {
  padding: 5px 10px;
  border: 1px solid #f48c4f;
  border-radius: 12px;
  font-size: small;
}
.password-rules {
  margin-top: 10px;
  font-size: 14px !important;
}

.valid {
  color: green;
}

.invalid {
  color: red;
}

.pass-validation {
  font-size: smaller;
  line-height: 0px;
}

.perfil-container {
  padding: 20px;
  max-width: 600px;
  margin: auto;
  background-color: #f6f6f6;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.main .container-fluid {
  padding: 50px 30px !important;
}

.perfil-titulo {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

.perfil-card {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

input[type="text"],
input[type="email"],
input[type="date"],
input[type="password"] {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

input[type="radio"] {
  margin-right: 5px;
}

input[type="radio"] {
  appearance: none;
  /* Remove o estilo padrão */
  -webkit-appearance: none;
  /* Compatibilidade com navegadores baseados no WebKit */
  background-color: white;
  border: 2px solid #ccc;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  outline: none;
  cursor: pointer;
  position: relative;
}

input[type="radio"]:checked {
  background-color: #ff5722;
  /* Cor da "bola" quando selecionada */
}

input[type="radio"]::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 2px;
  height: 2px;
  background-color: #ff5722;
  border-radius: 30%;
  display: none;
}

input[type="radio"]:checked::after {
  display: block;
}

.btn-salvar {
  display: block;
  width: 100%;
  padding: 10px;
  background-color: #ff7f50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.btn-salvar:hover {
  background-color: #ff5722;
}

/* Pop-up overlay and styling */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.popup {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  max-width: 80%;
  text-align: center;
}

.popup p {
  color: rgb(0, 0, 0);
  margin-bottom: 20px;
}

.btn-close {
  background-color: orange;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.btn-close:hover {
  background-color: #e96d2f;
}
</style>
